export const cardDoubleClick = (args) => {
  args.cancel = true;
};